export const TEST_ENVIRONMENT = 'test';
export const STG_ENVIRONMENT = 'stg';
export const PROD_ENVIRONMENT = 'live';
export const LOCAL_ENVIRONMENT = 'local';
export const DOCKER_ENVIRONMENT = 'docker';
